<nb-card>
    <nb-card-header>
        <h5>{{'searchResults' | translate}}</h5>
    </nb-card-header>`
    <nb-card-body>
        <ag-grid-angular #agGrid id="myGrid" style="width: 100%; height: 450px;" [attr.class]="class" [columnDefs]="columnDefs" [rowData]="searchResult" [enableRtl]='override.isRTL()' (gridReady)="onGridReady($event)" rowSelection="single" [pagination]="false"
            [suppressRowClickSelection]="true" [paginationAutoPageSize]="true">
        </ag-grid-angular>

    </nb-card-body>
</nb-card>